import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M301.298 113.778h420.451q113.778 0 113.778 113.778v297.03q0 113.778-113.778 113.778H301.298q-113.778 0-113.778-113.777V227.556q0-113.778 113.778-113.778Z" fill="#B0B7FF" /><path d="M170.667 329.785H852.38q113.778 0 113.778 113.778v358.741q0 113.778-113.778 113.778H170.667q-113.778 0-113.778-113.778V443.563q0-113.778 113.778-113.778Z" fill="#3C4EFF" /><path d="M172.316 710.699V532.267c0-27.407 19.869-49.693 44.331-49.693 24.448 0 44.317 22.286 44.317 49.693v178.346c0 27.407-19.869 49.693-44.317 49.693-24.462 0-44.33-22.187-44.33-49.607zm169.728 0V532.267c0-27.407 19.869-49.693 44.317-49.693 24.462 0 44.33 22.286 44.33 49.693v178.346c0 27.407-19.882 49.693-44.33 49.693-24.462 0-44.33-22.187-44.33-49.607z" fill="#FFF" /></svg>

const DevicesGroups = React.forwardRef((props, ref) => {
  return (
    <IconBase name="devices-groups" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

DevicesGroups.displayName = 'IconDevicesGroups'

export default DevicesGroups
